import { httpRequest } from "@/utils/HttpRequest";
import { ISearchPage, IPage } from "@/types/ScmTypes";

export interface ISCMJxcDetail {
    id: string, // string
    materialCode: string, // "F96194-33-Y",
    materialName: string, // "双H壳体",
    replaceCode: string, // "F96194-33-Y",
    typeCode: string, // "material-type.fast.c",
    typeName: string, // "C类-法士特",
    lastestPrice: number, // 193.8,
    startNum: number, // null,
    startAmount: number, // null,
    warehousingInNum: number, // 100,
    warehousingInAmount: number, // 19380,
    purchaseNum: number, // 100,
    purchaseAmount: number, // 19380,
    preturnNum: number, // 100,
    preturnAmount: number, // 19380,
    surplusNum: number, // null,
    surplusAmount: number, // null,
    lossNUm: number, // null,
    lossAmount: number, // null,
    warehouseOutNum: number, // 100,
    warehouseOutAmount: number, // 19380,
    warehouseOutCost: number, // 0,
    warehouseOutGrossProfit: number, // 0,
    giftNum: number, // 0,
    giftAmount: number, // 0,
    saleNum: number, // 0,
    saleAmount: number, // 0,
    saleCost: number, // 0,
    saleGrossProfit: number, // 0,
    sreturnNum: number, // 0,
    sreturnAmount: number, // 0,
    sreturnCost: number, // 0,
    sreturnGrossProfit: number, // 0,
    inventoryNum: number, // 0,
    lastestPriceAmount: number, // 0,
    shelfCode: string, // "207-K-05盈1",
    warehouseCode: string, // "wc",
    shopId: string, // "64eec0c1d6f37078b6b460e4cb0ac9d7"
}
export interface ISCMJxcDetailRow {
    id?: string, // string
    materialCode?: string, // "F96194-33-Y",
    materialName?: string, // "双H壳体",
    replaceCode?: string, // "F96194-33-Y",
    typeCode?: string, // "material-type.fast.c",
    typeName?: string, // "C类-法士特",
    lastestPrice?: number, // 193.8,
    startNum?: number, // null,
    startAmount?: number, // null,
    warehousingInNum?: number, // 100,
    warehousingInAmount?: number, // 19380,
    purchaseNum?: number, // 100,
    purchaseAmount?: number, // 19380,
    preturnNum?: number, // 100,
    preturnAmount?: number, // 19380,
    surplusNum?: number, // null,
    surplusAmount?: number, // null,
    lossNUm?: number, // null,
    lossAmount?: number, // null,
    warehouseOutNum?: number, // 100,
    warehouseOutAmount?: number, // 19380,
    warehouseOutCost?: number, // 0,
    warehouseOutGrossProfit?: number, // 0,
    giftNum?: number, // 0,
    giftAmount?: number, // 0,
    saleNum?: number, // 0,
    saleAmount?: number, // 0,
    saleCost?: number, // 0,
    saleGrossProfit?: number, // 0,
    sreturnNum?: number, // 0,
    sreturnAmount?: number, // 0,
    sreturnCost?: number, // 0,
    sreturnGrossProfit?: number, // 0,
    inventoryNum?: number, // 0,
    lastestPriceAmount?: number, // 0,
    shelfCode?: string, // "207-K-05盈1",
    warehouseCode?: string, // "wc",
    shopId?: string, // "64eec0c1d6f37078b6b460e4cb0ac9d7"
    [key: string]: any
}
export interface ISCMJxcDetailPurchasePin {
    supplierName: string,// "北京远大宏博建筑工程有限公司",
    paidAmount: string,// null,
    stockIoTotalAmount: string,// null,
    preferentialTypeCode: string,// "preferential_type.discount",
    tradeTypeCode: string,// "trade-type.sale",
    tradeTypeName: string,// "销售",
    supplierType: string,// null,
    supplierTypeCode: string,// null,
    supplierTypeName: string,// null,
    shopId: string,// "64eec0c1d6f37078b6b460e4cb0ac9d7",
    shopName: string,// "潍柴事业部",
    code: string,// "WCS-X22012500003",
    materialCode: string,// "128-502-65-82",
    materialName: string,// "中冷出气胶管",
    orderTypeCode: string,// "sale-type.direct",
    orderTypeName: string,// "直发",
    replaceCode: string,// "",
    typeCode: string,// "material-type.M26D",
    preferentialTypeName: string,// "折让",
    typeName: string,// "M26D类配件",
    price: string,// 306,
    num: string,// 1,
    realPrice: string,// null,
    amount: string,// 306,
    giftsNum: string,// 0,
    giftsAmount: string,// 0,
    warehouseName: string,// "直发库",
    shelfCode: string,// "直发",
    note: string,// "",
    planCode: string,// null,
    settleTime: string,// "2022-01-25",
    id: string,// null,
    createTime: string,// "2022-01-25",
    updateTime: string,// "2022-01-2",
    createUser: string,// "周晓凤",
    updateUser: string,// "周晓凤",
    payType: string,// "settle-type.credit",
    payTypeName: string,// "挂账",
    operator: string,// "周晓凤",
    total: string,// null,
    costAmount: string,// 255,
    profit: string,// 51,
    deleteFlag: string,// 0
}
//搜索条件
export interface ISCMJxcSearchFields {
    [key: string]: any
}

export interface ISCMJxcSearch
    extends ISCMJxcSearchFields, ISearchPage {

}
export interface IStatistics {
    startNum: number, // 19,　　　　　　　　　　　　　// 初始数量
    startAmount: number, // 3432667.08,　　　	   // 初始金额
    warehousingInNum: number, // 93169,			  //  入库数
    warehousingInAmount: number, // 11206529.91,	  //  入库金额
    warehouseOutNum: number, // 98739,			  //  出库数	
    warehouseOutAmount: number, // 10260791.56	  //  出库金额
    inventoryNum: number, //期末数量
    lastestPriceAmount: number //期末金额
    count?: number //库存种类
    countZf?: number // 直发种类
}

//进销存报表
class JxcService {
    async page(searchVo: ISCMJxcSearch) {
        const apiUrl = "/zzw-vrm/stock/from";
        return await httpRequest.post<IPage<ISCMJxcDetail>>(apiUrl, searchVo);
    }
    async export(searchVo: ISCMJxcSearch) {
        const apiUrl = "/zzw-vrm/stock/fromExcel";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }
    // 头部统计
    async statistics(searchVo: ISCMJxcSearch) {
        const apiUrl = "/zzw-vrm/stock/from/total";
        return await httpRequest.post<IStatistics>(apiUrl, searchVo, { timeout: 300000 });
    }
    async purchasePin(searchVo: ISCMJxcSearch) {
        const apiUrl = "/zzw-vrm/stock/details/purchasePin";
        return await httpRequest.post<IPage<ISCMJxcDetailPurchasePin>>(apiUrl, searchVo);
    }
    async purchasePinExport(searchVo: ISCMJxcSearch) {
        const apiUrl = "/zzw-vrm/stock/details/purchasePinExport";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }
}

export const jxcService = new JxcService();